import { AccessLevel } from './access-level.js';

export interface AuthToken {
    /**
     * Access level of this token
     */
    readonly accessLevel: AccessLevel;
    /**
     * Token id string for use with authentication
     */
    readonly id: string;
    /**
     * Iso 8601 timestamp when this token expires
     */
    readonly expiry: string;
    /**
     * Email may be attached if this is a player token
     */
    readonly email?: string;
}

/**
 * Take an expiry timestamp and generate a date which occurs at [ratio]% between the expiry time and now.
 * @param expiry ISO8601 timestamp.
 * @returns Date that occurs [ratio] of the way between now and the expiry.
 */
export function beforeExpiry(expiry: string, ratio = 0.75) {
    const now = Date.now();
    const expireMs = new Date(expiry).getTime() - now;
    return new Date(expireMs * ratio + now);
}
